
/* io control matrix */
export const PROJECT_DETAILS_GUI_CONTROL_MATRIX_ACTIVATE = 'PROJECT_DETAILS_GUI_CONTROL_MATRIX_ACTIVATE';
export const PROJECT_DETAILS_GUI_CONTROL_MATRIX_DEACTIVATE = 'PROJECT_DETAILS_GUI_CONTROL_MATRIX_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/actions/gui-control-matrix.ts